exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BQVUVNafetr4ElVq5rXCb{position:absolute;width:32px;height:32px;top:4px;cursor:pointer;pointer-events:all}html[dir] .BQVUVNafetr4ElVq5rXCb{text-align:center}html[dir=ltr] .BQVUVNafetr4ElVq5rXCb{right:4px}html[dir=rtl] .BQVUVNafetr4ElVq5rXCb{left:4px}.BQVUVNafetr4ElVq5rXCb:hover ._3cel-D_a3Rp0q7i7ziIHxn{color:\"[theme:neutralPrimary, default:#333333]\"}._3cel-D_a3Rp0q7i7ziIHxn{font-size:17px;font-weight:300;color:\"[theme:neutralSecondary, default:#666666]\";position:relative;display:block;line-height:32px;pointer-events:none}html[dir] ._3cel-D_a3Rp0q7i7ziIHxn{margin:auto}", ""]);

// exports
exports.locals = {
	"closeButtonContainer": "BQVUVNafetr4ElVq5rXCb",
	"icon": "_3cel-D_a3Rp0q7i7ziIHxn"
};